import React from 'react'
import GatsbyConfig from '../../../gatsby-config.js'
import { shuffle, setInLocal } from '../../utils/app-helpers'
import Image from '../partials/image'
import SiteFooter from '../partials/site-footer'
import HelmetWrapper from '../partials/helmet-wrapper'
import SiteHeader from '../partials/site-header'

import ernieAndRachell from '../../../static/images/avatars/ernie-and-rachell.jpg'
import gregLaurie from '../../../static/images/avatars/greg-laurie.jpg'
import jonMicah from '../../../static/images/avatars/jon-micah.jpg'
import kevinAndMerry from '../../../static/images/avatars/kevin-and-merry.jpg'
import kieranAndRuth from '../../../static/images/avatars/kieran-and-ruth.jpg'
import leonAndSue from '../../../static/images/avatars/leon-and-sue.jpg'
import macPowell from '../../../static/images/avatars/mac-powell.jpg'
import rigoAndLauren from '../../../static/images/avatars/rigo-and-lauren.jpg'
import thomasAndVeronica from '../../../static/images/avatars/thomas-and-veronica.jpg'

const images = {
  ernieAndRachell: ernieAndRachell,
  gregLaurie: gregLaurie,
  jonMicah: jonMicah,
  kevinAndMerry: kevinAndMerry,
  kieranAndRuth: kieranAndRuth,
  leonAndSue: leonAndSue,
  macPowell: macPowell,
  rigoAndLauren: rigoAndLauren,
  thomasAndVeronica: thomasAndVeronica,
}
const { siteMetadata: config } = GatsbyConfig

export default class ReviewsPage extends React.Component {
  componentDidMount() {
    const { trip } = this.props

    setInLocal('lsg.last-viewed-trip', trip)
  }

  render() {
    const { trip } = this.props
    const reviews = []
    const title = 'Testimonials'
    const description =
      'Hear what our travelers are saying about their experience on the Love ' +
      'Song Couples Getaway!'

    shuffle(config.reviews).forEach((review, key) => {
      reviews.push(
        <li key={`review-${key}`} className="with-image">
          <Image src={images[review.avatar]} alt="" />
          <blockquote dangerouslySetInnerHTML={{ __html: review.quote }} />
          <cite dangerouslySetInnerHTML={{ __html: review.cite }} />
        </li>
      )
    })

    return (
      <div className={`page-reviews trip-${trip}`}>
        <HelmetWrapper metaTitle={title} metaDescription={description} />
        <SiteHeader trip={trip} lock />
        <main>
          <div
            style={{
              backgroundImage: `url(/images/reviews-${trip}-splash.jpg)`,
            }}
            className="image mobile-100x40 desktop-300"
          />
          <div className="wrap">
            <div className="content">
              <h1>Testimonials</h1>
              <ol>{reviews}</ol>
            </div>
          </div>
        </main>
        <SiteFooter trip={trip} />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/reviews.js